<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div class="list-box" style="flex: 1">
      <ul class="list-table">
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
          @row-click="onRowClick"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
          />
          <el-table-column
            prop="xm"
            label="姓名"
            :formatter="
              (row, column, cellValue) =>
                $tab_Highlinght(cellValue, state.params.keywords)
            "
            width="120"
            fixed="left"
          />
          <el-table-column label="手机号" width="140">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="手机号"
                @click="$onCopy(row.lxdh)"
              >
                {{ row.lxdh }}
              </text>
            </template>
          </el-table-column>
          <el-table-column label="证件号" width="180">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click="$onCopy(row.zzhm)"
              >
                {{ row.zzhm }}
              </text>
            </template>
          </el-table-column>
          <el-table-column
            prop="update_time"
            label="更新时间"
            :formatter="$tab_TextFormat"
            width="120"
            align="center"
          />
          <el-table-column prop="phone" label="状态" min-width="120">
            <template #default="{ row }">
              <ul
                :style="{ color: row.declare_status == 0 ? '#1e90ff' : '#080' }"
              >
                {{
                  row.declare_status == 0 ? "待更新" : "已更新"
                }}
              </ul>
            </template>
          </el-table-column>
          <el-table-column prop="idtype" label="人员状态" min-width="120">
            <template #default>
              <text>正常</text>
            </template>
          </el-table-column>
          <el-table-column
            prop="withholding_agent_name"
            label="扣缴义务人"
            :formatter="$tab_ShowToolTip"
            min-width="160"
          />
          <el-table-column
            prop="aaa"
            label="统一社会信用代码"
            :formatter="$tab_TextFormat"
            min-width="140"
          />
          <el-table-column
            prop="tax_bureau_name"
            label="税局"
            :formatter="$tab_ShowToolTip"
            min-width="140"
          />
          <el-table-column
            prop="skssq"
            label="税款所属月份"
            :formatter="$tab_TextFormat"
            width="80"
            align="center"
          />
          <el-table-column
            prop="znjy"
            label="子女教育"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="jxjy"
            label="继续教育"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="fwzl"
            label="住房租金"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="sylr"
            label="赡养老人"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="yyezhl"
            label="3岁一下婴幼儿照顾"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljznjy"
            label="累计子女教育"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljjxjy"
            label="累计继续教育"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljfwdk"
            label="累计住房贷款利息"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljfwzl"
            label="累计住房租金"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljsylr"
            label="累计赡养老人"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
          <el-table-column
            prop="ljyyezhl"
            label="累计3岁一下婴幼儿照顾"
            :formatter="$tab_PriceFormat"
            width="100"
            align="right"
          />
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </ul>
    </div>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新专项附加扣除"
        @close="state.showAgent = false"
      >
        <c_Agent
          :skssq="state.params.skssq"
          v-if="state.showAgent"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_EssentialLog></c_EssentialLog>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { essential_record } from "@/http/essential";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.employee_id = props.employee_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      essential_record(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
